module.exports = __webpack_public_path__ + "img/notfoud.edcf7c34.png";